<ion-card class="card-container">
  <ion-card-content>
    <div data-cy="security-title-text" class="header-info">
      <h2>{{ 'i18n.profilePage.security.title' | translate }}</h2>
      <h3>
        {{
          (isMobile
            ? 'i18n.profilePage.security.subtitleMobile'
            : 'i18n.profilePage.security.subtitle'
          ) | translate
        }}
      </h3>
    </div>
    <div data-cy="security-account-info-fields" class="card-content">
      <p class="account-info">
        {{ 'i18n.profilePage.security.loginEmail' | translate }}:
        {{ accountInfo?.loginEmail }}
      </p>
      <p class="account-info">
        {{ 'i18n.profilePage.security.loginMobile' | translate }}:
        {{ accountInfo?.loginPhoneNumber }}
      </p>
      <p class="account-info">
        {{ 'i18n.profilePage.security.userName' | translate }}:
        {{ accountInfo?.userName }}
      </p>
      <p class="account-info">
        {{ 'i18n.profilePage.security.userSince' | translate }}:
        {{ accountInfo?.userSince | date: 'MM-dd-YYYY':'GMT' }}
      </p>
      <p class="account-info">
        {{ 'i18n.profilePage.security.loginDate' | translate }}:
        {{ accountInfo?.lastLoginDtm | date: 'MM-dd-YYYY':'GMT' }}
      </p>
    </div>
    <div class="footer-buttons">
      <ion-button
        data-cy="change-login-information-button"
        [ngClass]="
          disableChange() ? 'usf-fill-disabled-button' : 'usf-fill-green-button'
        "
        [disabled]="disableChange()"
        expand="block"
        (click)="changeLoginInformation()"
        >{{ 'i18n.profilePage.security.changeInfo' | translate }}</ion-button
      >
      <ion-button
        *ngIf="logoutAllSessions"
        data-cy="logout-all-sessions-button"
        [ngClass]="'usf-outline-green-button'"
        expand="block"
        (click)="logOutAllSessions()"
        >{{
          'i18n.profilePage.security.logOutAllSessions' | translate
        }}</ion-button
      >
    </div>
  </ion-card-content>
</ion-card>
